import React from 'react';

export const GetOfferSection: React.FC = () => {
  return (
    <section id="get-offer" className="py-20 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Get Your Free Cash Offer Today
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Ready to sell your garden apartment property? Contact us today for a free, no-obligation cash offer. Our team will evaluate your property and provide a fair offer within days.
            </p>
            
            <div className="space-y-6 mb-10">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Fast Response</h3>
                  <p className="text-gray-300">We'll review your property information and respond within 24-48 hours with initial feedback.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">No Obligation</h3>
                  <p className="text-gray-300">Our evaluation and offer are completely free with no commitment required from you.</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Confidential Process</h3>
                  <p className="text-gray-300">Your information is kept strictly confidential. We respect your privacy throughout the process.</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:+1234567890"
                className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 text-white font-bold rounded-lg hover:bg-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2 text-xl"></i>
                Call Us Now
              </a>
              <a
                href="mailto:info@sellapartmentscash.com"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2 text-xl"></i>
                Email Us
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/6abc9e8f2bdb6f7eef519189188341e4.jpg"
                alt="Get Your Cash Offer"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-2xl font-bold mb-2">
                  Start Your Sale Today
                </h3>
                <p className="text-white/90">
                  Join hundreds of satisfied garden apartment sellers who chose our simple, fast process.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};